import React, { useState, useEffect, useRef } from "react";
import DateConverter from "@heartinz/date_and_time_processor";
import dayjs from "dayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { CircularProgress } from "@mui/material";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import AxiosInstance from "../../../utils/AxiosInstance";
import Messages from "../../../constants/Messages";
import handleError from "../../../constants/handleError";
import GetServerLiveTime from "../../../constants/GetServerLiveTime";
import { useAuth } from "../../../context/AuthProvider";
import { Link } from "react-router-dom";
import ViewExpanseReport from "./ViewExpanseReport";
import { ChevronRightIcon, DownloadIcon, SpreadSheetIcon } from "../../../constants/Icons";

const ExpanseReport = () => {
  const [errors, setErrors] = useState("");

  const { isUser } = useAuth();
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const serverTime = GetServerLiveTime();

  var obj = {
    label: isUser.title,
    value: isUser.storeId,
    stype: isUser.stype,
  };

  const [isPreLoading, setPreLoading] = useState(true);
  const [isBtnLoading, setBtnLoading] = useState(false);

  const [options, setOptions] = useState([]);
  const [isSelectedStore, setSelectedStore] = useState(obj);
  const storeSelectedRef = useRef(null);

  const [isSaleReportData, setSaleReportData] = useState([]);

  const [isSelectedOption, setSelectedOption] = useState("BYSELF");
  const modeSelectedRef = useRef(null);

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const currentDate = new Date();
  // console.log("currentDate", currentDate);
  // console.log("serverTime", serverTime);

  const previousDate = new Date(serverTime.getTime() - 1000);
  const [fromDate, setFromDate] = useState(previousDate);
  const [toDate, setToDate] = useState(serverTime);

  const calculateDate = (baseDate, offsetDays) => {
    const resultDate = new Date(baseDate);
    resultDate.setDate(resultDate.getDate() + offsetDays);
    return resultDate;
  };

  // const handleFromDateChange = ([selectedDate]) => {
  //   const formattedDate = formatDate(selectedDate);
  //   setFromDate(selectedDate);
  //   const toDateValue = new Date(toDate);
  //   if (selectedDate > toDateValue) {
  //     const newFromDate = new Date(toDateValue.getTime() - 1000); // toDate - 1 day
  //     setFromDate(newFromDate);
  //     return;
  //   }

  //   const minToDate = calculateDate(selectedDate, -64);
  //   const maxToDate = new Date(
  //     Math.min(calculateDate(selectedDate, 64), serverTime)
  //   );
  //   if (toDateValue < minToDate || toDateValue > maxToDate) {
  //     setToDate(selectedDate);
  //   }
  // };

  // const handleToDateChange = ([selectedDate]) => {
  //   const fromDateValue = new Date(fromDate);
  //   const selectedToDate = new Date(selectedDate);

  //   if (selectedToDate.getTime() <= fromDateValue.getTime()) {
  //     const correctedFromDate = new Date(selectedToDate.getTime() - 1000); // toDate - 1 sec
  //     setFromDate(correctedFromDate);
  //   }
  //   setToDate(selectedDate);
  // };

  // const toDateMin = calculateDate(new Date(fromDate), -64);
  // const toDateMax = new Date(
  //   Math.min(calculateDate(new Date(fromDate), 64), serverTime)
  // );

  const handleFromDateChange = (newValue) => {
    if (!newValue) return;
    const selectedFrom = newValue.startOf("day");

    const maxAllowedTo = selectedFrom.add(64, "days");
    const finalMaxTo = maxAllowedTo.isAfter(dayjs(serverTime))
      ? dayjs(serverTime)
      : maxAllowedTo;

    setFromDate(selectedFrom.toDate());
    if (
      dayjs(toDate).isBefore(selectedFrom) ||
      dayjs(toDate).isAfter(finalMaxTo)
    ) {
      setToDate(finalMaxTo.toDate());
    }
  };

  const handleToDateChange = (newValue) => {
    if (!newValue) return;
    const selectedTo = newValue.endOf("day");

    if (selectedTo.isBefore(dayjs(fromDate))) {
      setFromDate(selectedTo.startOf("day").toDate());
    }
    setToDate(selectedTo.toDate());
  };

  const toDateMin = fromDate;
  const toDateMax = dayjs(fromDate).add(64, "day").isAfter(dayjs(serverTime))
    ? dayjs(serverTime)
    : dayjs(fromDate).add(64, "day");

  const handleListStore = async () => {
    setPreLoading(true);
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(`list-store`);
      const options = formatOptions(response.data.results, isUser.stype);
      setOptions(options);
      const userStore = options.find(
        (option) => option.value === isUser.storeId
      );
      setSelectedStore(userStore);
      handleSaleReport();
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setPreLoading(false);
    }
  };

  const formatOptions = (data, userType) => {
    if (userType === "MAIN") {
      const mainOption = {
        label: data.title,
        value: data._id,
        stype: "MAIN",
      };

      const subOptions = data.subs.map((subStore) => ({
        label: subStore.title,
        value: subStore._id,
        stype: "SUB",
      }));

      const hubOptions = data.subs.reduce((acc, subStore) => {
        if (subStore.hubs && subStore.hubs.length > 0) {
          const hubs = subStore.hubs.map((hub) => ({
            label: hub.title,
            value: hub._id,
            stype: "HUB",
          }));
          return acc.concat(hubs);
        }
        return acc;
      }, []);

      return [mainOption, ...subOptions, ...hubOptions];
    }

    if (userType === "SUB") {
      const subOption = {
        label: data.title,
        value: data._id,
        stype: "SUB",
      };

      let hubOptions = [];
      if (data.hubs && data.hubs.length > 0) {
        hubOptions = data.hubs.map((hub) => ({
          label: hub.title,
          value: hub._id,
          stype: "HUB",
        }));
      }

      return [subOption, ...hubOptions];
    }

    if (userType == "HUB") {
      const hubOptions = {
        label: data.title,
        value: data._id,
        stype: "HUB",
      };
      return [hubOptions];
    }
    return [];
  };

  const getColor = (status) => {
    switch (status.toLowerCase()) {
      case "main":
        return "bg-label-orange";
      case "sub":
        return "bg-label-peach";
      case "hub":
        return "bg-label-night";
      default:
        return "bg-label-secondary";
    }
  };

  const renderOptionLabel = ({ label, stype }) => {
    let marginRight;
    let fontWeight;
    let badgePadding;
    let fontSize;

    if (stype === "MAIN") {
      marginRight = "0px";
      fontWeight = "500";
      fontSize = "14.5px";
      badgePadding = "2px 8px";
    } else if (stype === "SUB") {
      marginRight = "2px";
      fontWeight = "400";
      fontSize = "14px";
      badgePadding = "2px 12px";
    } else if (stype === "HUB") {
      marginRight = "4px";
      fontWeight = "300";
      fontSize = "13.5px";
      badgePadding = "2px 14px";
    }

    return (
      <span
        style={{
          display: "flex",
          alignItems: "center",
          marginLeft: marginRight,
        }}
      >
        <span
          className={`badge rounded-pill ${getColor(stype)}`}
          style={{
            marginRight: "5px",
            padding: badgePadding,
          }}
        >
          {stype}
        </span>
        <span style={{ fontWeight, fontSize }}>- {label}</span>
      </span>
    );
  };

  const handleSelectStore = (selected) => {
    setSelectedStore(selected);
  };

  const validateForm = () => {
    const errors = {};
    if (!isSelectedStore) {
      errors.store = Messages.ERROR.EMPTY_STORE;
    }
    if (!isSelectedOption) {
      errors.mode = Messages.ERROR.FIELD_REQUIRED;
      modeSelectedRef.current?.focus();
    }
    setErrors(errors);
    if (Object.keys(errors).length > 0) {
      const firstErrorField = Object.keys(errors)[0];
      switch (firstErrorField) {
        case "store":
          storeSelectedRef.current?.focus();
          break;
        case "MODE":
          modeSelectedRef.current?.focus();
          break;
        default:
          break;
      }
    }
    return Object.keys(errors).length === 0;
  };

  const handleSaleReport = async () => {
    if (!validateForm()) return;
    setPreLoading(true);
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      var data = {
        storeid: isSelectedStore.value,
        mode: isSelectedOption,
        fromdate: encodeURIComponent(
          DateConverter.convertToTimeZone(
            fromDate.toISOString(),
            isUser.timezone
          )
        ),
        todate: encodeURIComponent(
          DateConverter.convertToTimeZone(toDate.toISOString(), isUser.timezone)
        ),
      };

      const response = await AxiosInstance.get(
        `module/expense/?startdate=${data.fromdate}&enddate=${data.todate}`
      );
      setSaleReportData(response.data.results);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setPreLoading(false);
      setBtnLoading(false);
    }
  };

  const exportToCSV = () => {
    if (!isSaleReportData?.expenseData?.length) {
      showAlert("warning", "No data available to export");
      return;
    }

    // 1. Headers
    const headers = `S No,Date,Title,Description,PayMode,Amount,`;

    const clean = (val) => (val ?? "").toString().replace(/[\r\n;]/g, " ");

    // 2. Rows

    const rows = isSaleReportData?.expenseData
      ?.map((item, index) => {
        const row = [
          index + 1,
          // clean(item?.saleno),
          clean(
            DateConverter.ISOToDisplayFormat(
              item?.expensedate,
              isUser?.timezone
            ).date
          ),
          clean(item?.title),
          clean(item?.description),
          clean(item?.paymode),
          clean(CurrencyConverter.toCurrency(Number(item?.amount) || 0, "INR")),
          // clean(item?.saleby?.storename),
        ];
        return row.join(",");
      })
      .join("\n");

    // 3. Total Row
    const totalRow = [
      "",
      "TOTAL",
      "",
      "",
      "",
      `${CurrencyConverter.toCurrency(
        isSaleReportData?.totalexpense || 0,
        "INR"
      )}`,
    ].join(",");

    // 4. Summary Tax Section (in "Heading, Value" format)
    // const summaryTaxSection = [
    //   [
    //     "Cash",
    //     clean(
    //       CurrencyConverter.toCurrency(
    //         Number(isSaleReportData?.cashamount) || 0,
    //         "INR"
    //       )
    //     ),
    //   ],
    //   [
    //     "Card",
    //     clean(
    //       CurrencyConverter.toCurrency(
    //         Number(isSaleReportData?.cardamount) || 0,
    //         "INR"
    //       )
    //     ),
    //   ],
    //   [
    //     "Online Pay (UPI)",
    //     clean(
    //       CurrencyConverter.toCurrency(
    //         Number(isSaleReportData?.onlineamount) || 0,
    //         "INR"
    //       )
    //     ),
    //   ],
    //   [
    //     "Discount",
    //     clean(
    //       CurrencyConverter.toCurrency(
    //         Number(isSaleReportData?.totaldiscount) || 0,
    //         "INR"
    //       )
    //     ),
    //   ],
    // ]
    //   .map(([heading, value]) => `${heading},${value}`)
    //   .join("\n");

    // 5. Combine everything
    const csvContent = [headers, rows, totalRow, ""].join("\n");

    const BOM = "\uFEFF";
    const blob = new Blob([BOM + csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    const from = formatDate(fromDate);
    const to = formatDate(toDate);
    link.setAttribute("href", url);
    link.setAttribute(
      "download",
      `ExpenseReport_Report_${from}_to_${to}.csv`
    );
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleReset = async () => {
    setSelectedStore("");
  };

  const handleSelectOption = (event) => {
    const selected = event.target.value;
    setSelectedOption(selected);
  };

  useEffect(() => {
    handleListStore();
  }, []);

  return (
    <div>
      <div className="page-wrapper">
        <div className="page-content">
          <div className="page-breadcrumb d-flex align-items-center paddingBottom">
            <div className="breadcrumb-title pe-3">Expense Report</div>
            <div className="ms-auto">
              <div className="dropdown">
                <button
                  className="btn btn-sm btn-export dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <DownloadIcon/> Export
                </button>
                <ul className="dropdown-menu">
                  <li>
                    <Link className="dropdown-item" onClick={exportToCSV}>
                      <SpreadSheetIcon/>{" "}
                      <span className="icon-text">Excel (CSV)</span>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-2">
              <div className="card">
                <div className="card-body">
                  <div className="row g-3">
                    <div className="col-12">
                      <label className="form-label w-100">
                        From Date <span className="text-danger"> *</span>
                      </label>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          value={dayjs(fromDate)}
                          maxDate={dayjs(serverTime)}
                          format="DD MMM YYYY"
                          onChange={handleFromDateChange}
                          slotProps={{
                            textField: {
                              className: "form-control",
                              size: "small",
                              inputProps: { readOnly: true },
                              onKeyDown: (e) => e.preventDefault(),
                              sx: {
                                "& .MuiInputBase-input": {
                                  cursor: "pointer", 
                                },
                              },                            
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </div>
                    <div className="col-12">
                      <label className="form-label w-100">
                        To Date <span className="text-danger"> *</span>
                      </label>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          value={dayjs(toDate)}
                          minDate={dayjs(toDateMin)}
                          maxDate={dayjs(toDateMax)}
                          format="DD MMM YYYY"
                          onChange={handleToDateChange}
                          slotProps={{
                            textField: {
                              className: "form-control",
                              size: "small",
                              inputProps: { readOnly: true },
                              onKeyDown: (e) => e.preventDefault(),
                              sx: {
                                "& .MuiInputBase-input": {
                                  cursor: "pointer", 
                                },
                              },                            
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </div>

                    {/* <div className="col-12">
                      <label className="form-label w-100">
                        Store <span className="text-danger"> *</span>
                      </label>
                      <Select
                        options={options}
                        onChange={handleSelectStore}
                        value={isSelectedStore}
                        ref={storeSelectedRef}
                        isSearchable
                        formatOptionLabel={renderOptionLabel}
                      />
                      {errors.store && (
                        <div className="invalid-feedback">{errors.store}</div>
                      )}
                    </div> */}

                    {/* <div className="col-lg-12">
                      <label className="form-label w-100">
                        Generated <span className="text-danger"> *</span>
                      </label>
                      <select
                        className="form-select"
                        onChange={handleSelectOption}
                        ref={modeSelectedRef}
                        value={isSelectedOption}
                      >
                        <option value="">Select</option>
                        <option value="BYSELF">By Self</option>
                        {isUser.stype !== "HUB" && (
                          <option value="BYOWNED">By Owned</option>
                        )}
                      </select>
                      {errors.mode && (
                        <div className="invalid-feedback">{errors.mode}</div>
                      )}
                    </div> */}

                    <div className="col-12">
                      <div className="d-grid">
                        {isBtnLoading ? (
                          <button
                            className="btn btn-primary pb-0 text-right"
                            disabled
                          >
                            <CircularProgress
                              size={22}
                              className="text-white"
                            />
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="btn btn-primary"
                            id="salesreportbtn"
                            onClick={handleSaleReport}
                          >
                            Generate <ChevronRightIcon/>
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-10">
              <div className="card p-3">
                <ViewExpanseReport
                  isData={isSaleReportData}
                  isPreLoading={isPreLoading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpanseReport;
